import React from "react";
import { FaCalendarDay, FaBuilding, FaClock, FaRupeeSign, FaHourglassHalf } from "react-icons/fa";

const Card = ({ icon, title, value }) => (
  <div className="bg-white shadow-md rounded-2xl p-5 flex items-center gap-4 hover:shadow-lg transition">
    <div className="text-2xl text-indigo-500">{icon}</div>
    <div>
      <p className="text-gray-500 text-sm">{title}</p>
      <h2 className="text-xl font-semibold">{value}</h2>
    </div>
  </div>
);

const QuickStatsCards = ({ summary }) => {
  if (!summary) return null;

  return (
    <div className="grid md:grid-cols-5 gap-4 mb-8">

      <Card
        icon={<FaCalendarDay />}
        title="Today's Events"
        value={summary.TodaysEvents || 0}
      />

      <Card
        icon={<FaBuilding />}
        title="Total Halls"
        value={summary.TotalHalls || 0}
      />

      <Card
        icon={<FaClock />}
        title="Upcoming Bookings"
        value={summary.UpcomingBookings || 0}
      />

      <Card
        icon={<FaRupeeSign />}
        title="Today's Revenue"
        value={`₹${summary.TodaysRevenue || 0}`}
      />

      <Card
        icon={<FaHourglassHalf />}
        title="Pending Payments"
        value={`₹${summary.PendingPayments || 0}`}
      />

    </div>
  );
};

export default QuickStatsCards;